export const config = {
  googleToken: 'accessToken',
  apiToken: 'token',
  themeStorageKey: 'sovoro2.office.theme',
  env: {
    apiHost: process.env.REACT_APP_API_HOST,
    apiVersion: process.env.REACT_APP_API_VERSION,
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    webHost: process.env.REACT_APP_WEB_HOST,
  },
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  },
};
